<template>
  <v-row>
    <v-col cols="6" v-for="(item, index) in questions" :key="'Image' + index">
      <v-file-input
        :rules="[rules.required]"
        v-model="item.question_file"
        @change="onFilePicked($event, index)"
        append-icon="mdi-image"
        accept="image/*"
        show-size
        prepend-icon
        placeholder="Click to select an image"
      >
        <template v-slot:selection v-if="typeof item.question_file === 'string'"
          >You already saved a file. Click to save a new one...</template
        >
      </v-file-input>
      <v-img min-height="200" contain aspect-ratio="4/3" :src="images[index]">
        <template #placeholder>
          <v-container class="py-0">
            <v-row align="center" justify="center" class="custom-row">
              <v-icon size="56">mdi-image</v-icon>
            </v-row>
          </v-container>
        </template>
      </v-img>
      <v-text-field
        :rules="[rules.required]"
        v-model="item.good_answer"
        label="Correct Answer"
      ></v-text-field>
    </v-col>
  </v-row>
</template>
<script>
import rulesMixin from "@/mixins/rulesMixin";
import { postQuestions } from "@/api/api";

export default {
  mixins: [rulesMixin],
  props: {
    question_group: {
      required: false,
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      questions: [],
      defaultQuestions: () => [
        {
          title: "Images",
          question_file: undefined,
          good_answer: "",
        },
        {
          title: "Images",
          question_file: undefined,
          good_answer: "",
        },
        {
          title: "Images",
          question_file: undefined,
          good_answer: "",
        },
        {
          title: "Images",
          question_file: undefined,
          good_answer: "",
        },
        {
          title: "Images",
          question_file: undefined,
          good_answer: "",
        },
        {
          title: "Images",
          question_file: undefined,
          good_answer: "",
        },
      ],
      images: ["", "", "", "", "", ""],
    };
  },
  methods: {
    onFilePicked(e, index) {
      try {
        const files = e;
        let src = "";
        if (files !== undefined) {
          const fileName = files.name;
          if (fileName.lastIndexOf(".") <= 0) {
            return;
          }
          const fr = new FileReader();
          fr.readAsDataURL(files);
          fr.addEventListener("load", () => {
            src = fr.result;
            this.images.splice(index, 1, src);
          });
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
    async save(uuid) {
      let question_group = {
        uuid,
        questions: this.questions,
      };
      try {
        const response = await postQuestions(question_group);
        this.questions = response.questions;
        return response;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log(error);
      }
    },
  },
  created() {
    if (this.question_group.questions) {
      this.questions = this.question_group.questions;
      this.questions.forEach((element, index) => {
        this.images.splice(index, 1, element.question_file);
      });
    } else this.questions = this.defaultQuestions();
  },
};
</script>
<style scoped>
.custom-row {
  border: 1px lightgray solid;
  border-radius: 4px;
  height: 120px;
}
.v-img:hover {
  cursor: pointer;
}
</style>
